export const SCRIPT_TEXT_FORMAT =
  "Write the script as formatted document text: headings and paragraphs. Bold and lists are allowed. Do not use code blocks, fenced code, or preformatted blocks.";

export const GENERATE_PROMPT = `Generate the creator script from the selected concept.\n\n${SCRIPT_TEXT_FORMAT}`;
